import { createGetEndpoint } from '@sonar-software/sonar-http';
import { DataSecurityMonitoredObjects } from '@types';

export const getDataSecurityMonitoredObjects = createGetEndpoint<void, DataSecurityMonitoredObjects>(
	'/api/v3/data-security/organization/monitored-entity-definitions'
);
